import React, { useState } from "react";
import MainSidebar from "./Mainsidebar";
import UserNavbar from "./UserNavbar";
import UserFooter from "./UserFooter";
import "../Style/EyeSenseDownload.css";

export default function EyeSenseDownload() {
  const [hamburger, sethamburger] = useState(true);
  const [isRightMenu, setisRightMenu] = useState(false);
  const [isSearchShow, setIsSearchShow] = useState(false);
  const [fullScreen, setFullScreen] = useState(true);

  // EyeSense Web Application URL
  const eyeSenseUrl = "https://eyesense.indsac.com/";

  const currentVersion = process.env.REACT_APP_EYESENSE_VERSION || "2.1.5";

  // Static release info (future: fetch from API)
  const releaseInfo = {
    version: currentVersion,
    releaseDate: "15 July 2026",
    platform: "Windows 64-bit",
    fileSize: "248 MB",
    sha256: "a3f2c9e1b7d4f8a0e6c5b2d9f1a4e7c3b8d0f5a2e9c6b3d7f0a1e4c8b5d2f6",
    publisher: "Indsac Entelipro Pvt. Ltd.",
    features: [
      "Enhanced AI object detection accuracy by 15%",
      "Multi-camera sync support for up to 100 cameras",
      "New dashboard widgets for real-time analytics",
      "Cloud backup scheduling with automatic sync",
    ],
    fixes: [
      "Fixed intermittent connection loss with IP cameras",
      "Resolved memory leak during extended recording sessions",
      "Fixed notification delivery delays on slow networks",
    ],
    improvements: [
      "Optimized video processing pipeline for 30% faster analysis",
      "Improved face recognition speed in crowded environments",
      "Reduced application startup time by 40%",
    ],
  };

  const installationSteps = [
    {
      title: "Download EyeSense.exe",
      description:
        'Click the "Download EyeSense Desktop" button above to download the latest installer.',
    },
    {
      title: "Run as Administrator",
      description:
        "Right-click the downloaded file and select 'Run as Administrator' to begin installation.",
    },
    {
      title: "Allow Windows Security",
      description:
        "If Windows Defender SmartScreen appears, click 'More info' and then 'Run anyway'.",
    },
    {
      title: "Login with Your Credentials",
      description:
        "Use your EyeSense Portal login credentials to authenticate the desktop application.",
    },
    {
      title: "Start Monitoring Cameras",
      description:
        "Add your camera feeds, configure detection zones, and start AI-powered surveillance.",
    },
  ];

  const systemRequirements = [
    { label: "Operating System", value: "Windows 10 / Windows 11", icon: "fas fa-desktop" },
    { label: "Architecture", value: "64-bit (x64)", icon: "fas fa-microchip" },
    { label: "Minimum RAM", value: "4 GB", icon: "fas fa-memory" },
    { label: "Recommended RAM", value: "8 GB", icon: "fas fa-memory" },
    { label: "Disk Space", value: "500 MB free", icon: "fas fa-hdd" },
    { label: "Internet", value: "Required (broadband)", icon: "fas fa-wifi" },
    { label: "Display", value: "1280 x 720 minimum", icon: "fas fa-tv" },
  ];

  // Screen Layout Handlers
  const handleScreenEnter = () => {
    setFullScreen(false);
    document.body.requestFullscreen();
  };
  const handleScreenExit = () => {
    setFullScreen(true);
    document.exitFullscreen();
  };
  const handelShow = () => setIsSearchShow(!isSearchShow);
  const handelRightMenuShow = () => setisRightMenu(!isRightMenu);
  const handleclickonbutton = (hamburger) => {
    if (document.documentElement.clientWidth <= 800) {
      return { display: hamburger && "none" };
    }
  };
  const handleclickonbutton1 = (hamburger) => {
    if (document.documentElement.clientWidth <= 800) {
      return { display: hamburger && "none" };
    }
  };

  // Visit EyeSense Handler
  const handleVisitEyeSense = () => {
    window.open(eyeSenseUrl, "_blank", "noopener,noreferrer");
  };

  return (
    <div className="con1 d-flex">
      <div className="subcon1" style={handleclickonbutton1(hamburger)}>
        <MainSidebar hamburger={hamburger} sethamburger={sethamburger} />
      </div>
      <div className="subcon2" style={handleclickonbutton(hamburger)}>
        <UserNavbar
          hamburger={hamburger}
          sethamburger={sethamburger}
          handelRightMenuShow={handelRightMenuShow}
          handelShow={handelShow}
          isSearchShow={isSearchShow}
          handleScreenEnter={handleScreenEnter}
          handleScreenExit={handleScreenExit}
          fullScreen={fullScreen}
        />

        <div className="eyesense-download-wrapper">
          {/* Page Header */}
          <div className="d-flex flex-column flex-md-row justify-content-between align-items-md-center mb-4">
            <div>
              <h4 className="font-weight-bold mb-1" style={{ color: "#0f172a" }}>
                <i className="fas fa-download text-primary mr-2"></i>EyeSense Download Center
            </h4>
            <span className="text-muted small">
              Access the EyeSense AI-powered surveillance web application
            </span>
            </div>
          </div>

          {/* Hero Download Card */}
          <div className="es-hero-card mb-4">
            <div className="row align-items-center">
              <div className="col-lg-8 mb-4 mb-lg-0">
                <div className="es-hero-icon">
                  <i className="fas fa-eye"></i>
                </div>
                <h2 className="es-hero-title">EyeSense Desktop Application</h2>
                <p className="es-hero-subtitle">
                  AI-powered surveillance system with real-time threat detection, face recognition,
                  and automated monitoring for enterprise security.
                </p>

                <div className="es-meta-row">
                  <span className="es-version-badge">
                    <i className="fas fa-tag"></i> v{releaseInfo.version}
                  </span>
                  <span className="es-platform-badge">
                    <i className="fas fa-globe"></i> Web Application
                  </span>
                  <span className="es-meta-item">
                    <i className="fas fa-calendar-alt"></i> Released: {releaseInfo.releaseDate}
                  </span>
                </div>

                <button
                  className="btn btn-es-download"
                  onClick={handleVisitEyeSense}
                  style={{ transition: "all 0.3s ease" }}
                >
                  <i className="fas fa-external-link-alt"></i>
                  Visit EyeSense
                </button>
              </div>

              <div className="col-lg-4 text-center d-none d-lg-block">
                <div style={{ fontSize: "6rem", opacity: 0.15, color: "#60a5fa" }}>
                  <i className="fas fa-shield-alt"></i>
                </div>
              </div>
            </div>
          </div>

          {/* Info Cards Row */}
          <div className="row mb-4">
            {/* Release Notes */}
            <div className="col-lg-6 mb-4 mb-lg-0">
              <div className="es-card h-100">
                <div className="es-card-header">
                  <h6>
                    <i className="fas fa-clipboard-list text-primary mr-2"></i>
                    Release Notes — v{releaseInfo.version}
                  </h6>
                </div>
                <div className="es-card-body">
                  <div className="es-release-category">
                    <i className="fas fa-star text-success mr-1"></i> New Features
                  </div>
                  {releaseInfo.features.map((item, idx) => (
                    <div key={`feature-${idx}`} className="es-release-item feature">
                      <i className="fas fa-check-circle"></i>
                      <span>{item}</span>
                    </div>
                  ))}

                  <div className="es-release-category">
                    <i className="fas fa-bug text-danger mr-1"></i> Bug Fixes
                  </div>
                  {releaseInfo.fixes.map((item, idx) => (
                    <div key={`fix-${idx}`} className="es-release-item fix">
                      <i className="fas fa-wrench"></i>
                      <span>{item}</span>
                    </div>
                  ))}

                  <div className="es-release-category">
                    <i className="fas fa-bolt text-primary mr-1"></i> Improvements
                  </div>
                  {releaseInfo.improvements.map((item, idx) => (
                    <div key={`imp-${idx}`} className="es-release-item improvement">
                      <i className="fas fa-arrow-up"></i>
                      <span>{item}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            {/* Installation Instructions */}
            <div className="col-lg-6">
              <div className="es-card h-100">
                <div className="es-card-header">
                  <h6>
                    <i className="fas fa-cogs text-info mr-2"></i>
                    Installation Guide
                  </h6>
                </div>
                <div className="es-card-body">
                  {installationSteps.map((step, idx) => (
                    <div key={`step-${idx}`} className="es-step">
                      <div className="es-step-number">{idx + 1}</div>
                      <div className="es-step-text">
                        <strong>{step.title}</strong>
                        <br />
                        {step.description}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>

          {/* System Requirements & Verification Row */}
          <div className="row mb-4">
            {/* System Requirements */}
            <div className="col-lg-6 mb-4 mb-lg-0">
              <div className="es-card h-100">
                <div className="es-card-header">
                  <h6>
                    <i className="fas fa-laptop text-warning mr-2"></i>
                    System Requirements
                  </h6>
                </div>
                <div className="es-card-body">
                  {systemRequirements.map((req, idx) => (
                    <div key={`req-${idx}`} className="es-req-row">
                      <span className="es-req-label">
                        <i className={req.icon}></i> {req.label}
                      </span>
                      <span className="es-req-value">{req.value}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            {/* Download Verification */}
            <div className="col-lg-6">
              <div className="es-card h-100">
                <div className="es-card-header">
                  <h6>
                    <i className="fas fa-fingerprint text-success mr-2"></i>
                    Download Verification
                  </h6>
                </div>
                <div className="es-card-body">
                  <div className="mb-3">
                    <p className="text-muted small mb-2">
                      Verify the integrity of your download by comparing the SHA-256 hash below
                      with the hash of the downloaded file.
                    </p>
                  </div>

                  <div className="mb-3">
                    <label className="small font-weight-bold text-muted d-block mb-1">
                      SHA-256 Checksum
                    </label>
                    <div className="es-hash-display">{releaseInfo.sha256}</div>
                  </div>

                  <div className="mb-3">
                    <label className="small font-weight-bold text-muted d-block mb-1">
                      Publisher
                    </label>
                    <div className="d-flex align-items-center gap-2">
                      <i className="fas fa-building text-primary" style={{ fontSize: "0.85rem" }}></i>
                      <span style={{ fontSize: "0.875rem", fontWeight: 600, color: "#0f172a" }}>
                        {releaseInfo.publisher}
                      </span>
                    </div>
                  </div>

                  <div className="mb-0">
                    <label className="small font-weight-bold text-muted d-block mb-1">
                      Digital Signature
                    </label>
                    <div className="d-flex align-items-center gap-2">
                      <i className="fas fa-check-circle text-success" style={{ fontSize: "0.85rem" }}></i>
                      <span style={{ fontSize: "0.875rem", fontWeight: 600, color: "#166534" }}>
                        Digitally Signed — Verified Publisher
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Support & Help */}
          <div className="row mb-4">
            <div className="col-12">
              <div className="es-card">
                <div className="es-card-body">
                  <div className="d-flex flex-column flex-md-row align-items-md-center justify-content-between">
                    <div className="mb-3 mb-md-0">
                      <h6 className="font-weight-bold mb-1" style={{ color: "#0f172a" }}>
                        <i className="fas fa-headset text-primary mr-2"></i>
                        Need Help with Installation?
                      </h6>
                      <span className="text-muted small">
                        Contact our support team for assistance with setup, configuration, or troubleshooting.
                      </span>
                    </div>
                    <div className="d-flex gap-2 flex-wrap">
                      <a
                        href="mailto:support@entelipro.com"
                        className="btn btn-outline-primary btn-sm"
                        style={{ borderRadius: "6px", fontWeight: 600 }}
                      >
                        <i className="fas fa-envelope mr-1"></i> Email Support
                      </a>
                      <a
                        href="https://entelipro.com/eyesense"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="btn btn-outline-secondary btn-sm"
                        style={{ borderRadius: "6px", fontWeight: 600 }}
                      >
                        <i className="fas fa-external-link-alt mr-1"></i> Product Page
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <UserFooter />
      </div>
    </div>
  );
}
